import "../../assets/css/bootstrap.min.css";
import plus from "../../assets/icons/plus.png";
import download from "../../assets/icons/download.png";
import "../experiment/newlayout.css";
import AliceCarousel from "react-alice-carousel";
import "../experiment/experiment.css";
import "react-alice-carousel/lib/alice-carousel.css";
import {
  Card,
  Col,
  Image,
  message,
  Modal,
  notification,
  Row,
  Select,
  Tooltip,
} from "antd";
import NavButtonExperiment from "../../components/experiment/nav-button";
import NavButtonExperimentNew from "../../components/experiment/nav-button-new";
import { useSpring } from "react-spring/three";
import React, { useState, useEffect, createRef, useCallback } from "react";
import { Canvas } from "react-three-fiber";
import "../experiment/styles.css";
import utils from "../../utility/utils";
import { CanvasImage } from "../../components/experiment/canvas-image";
import { OverlayLoading } from "../../components/shared/overlay-loading";
import { skeletonItems } from "../../components/experiment/skeleton-items";
import { network } from "../../utility/network";
import square_taco from "../../assets/images/taco-square.webp";
import { Option } from "antd/lib/mentions";
import { toPng } from "html-to-image";
import { ActionButton } from "../../components/experiment/action-button";
import { UploadField } from "../../components/shared/upload_field";
import { Link, useSearchParams } from "react-router-dom";
import watermark from "../../assets/images/logo.png";
import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { LinkOutlined } from "@ant-design/icons";
import { ExperimentAction } from "../../components/experiment/experimen-action";
import { Helmet } from "react-helmet";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import html2canvas from "html2canvas";
import downloadjs from "downloadjs";
import arrowLeft from "../../assets/icons/arrow-left-2.png";
import { ExperimentActionV2 } from "../../components/experiment/experimen-action-v2";
import { useTranslation } from "react-i18next";
import { ExperimentActionPrespektif } from "../../components/experiment/experimen-action-prespektif";
import "./perspektif.css";
import { ExperimentActionPrespektifDisabled } from "../../components/prepektif/experimen-action-prespektif-disabled";
import { SliderZoom } from "../../components/prepektif/slider-zoom";
import { SliderArah } from "../../components/prepektif/slider-arah";
import Back from "../../components/back/back";
import logoBlack from "../../assets/images/Logo_Floor_View_Black.png";

export default function NewPrespektif() {
  const { t, i18n } = useTranslation();

  const [floors, setFloors] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(0);
  const [selectedPattern, setSelectedPattern] = useState(0);
  const [patterns, setPatterns] = useState([]);
  const [patternsAssets, setPatternsAssets] = useState([]);
  const [showed, setShowed] = useState("category");
  const [choosedFloor, setChoosedFloor] = useState(null);
  const [tempRoom, setTempRoom] = useState({});

  const [image, setImage] = useState("");
  const [originImage, setOriginImage] = useState("");
  const [loading, setLoading] = useState(true);

  const [fullImgDesktop, setFUllImgDesktop] = useState("");
  const [pngImgDesktop, setPngImgDesktop] = useState("");
  const [fullImgMobile, setFUllImgMobile] = useState("");
  const [pngImgMobile, setPngImgMobile] = useState("");

  const [searchParams] = useSearchParams();

  const [styleWidth, setStyleWidth] = useState({});
  const [loadingUp, setLoadingUp] = useState(false);

  const [valueZoom, setValZoom] = useState(0);
  const [valueArah, setValArah] = useState(0);
  const [edit, setEdit] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const [props] = useSpring(() => ({
    pos: [0, 0, 0],
    scale: [0.9, 0.9, 0.9],
    rotation: [0, 0, 0],
    position: [0, 0, 0],
    config: { mass: 10, tension: 1000, friction: 300, precision: 0.00001 },
  }));

  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  const [{ rotation }, setRotation] = useSpring(() => ({
    // positioning the floor [X, Y, Z]
    // -50, biar kemiringannya pas defaultnya
    rotation: [-50, 0, 0],
    position: [0, 0, 0],
    config: { mass: 10, tension: 1000, friction: 300, precision: 0.00001 },
  }));

  useEffect(() => {
    handleCekToken();
    handleFetchRoom();
  }, []);

  const getArah = (id) => {
    network.post(
      `detail-perspektif`,
      {
        room_id: searchParams.get("id"),
        produk_id: id,
      },
      (res) => {
        if (res.data) {
          handleMotif(res.data.posisi_motif, res.data.arah_motif);
          setEdit(true);
        } else {
          setEdit(false);
        }
      },
      (err) => {
        console.log("err", err);
      }
    );
  };

  const handleMotif = (posisi, arah) => {
    setValArah(arah);
    for (let index = 0; index < arah; index++) {
      if (index > 0) {
        handleChangeSlider(index);
      }
    }

    setValZoom(posisi + 1);
    for (let index = 88; index < posisi; index++) {
      if (index > 0) {
        handleArrangeFloor(index);
      }
    }
  };

  const saveArah = () => {
    network.post(
      `save-perspektif`, 
      {
        room_id: searchParams.get("id"),
        produk_id: selectedProduct,
        posisi_motif: valueZoom,
        arah_motif: valueArah,
        token: searchParams.get("auth"),
      },
      (res) => {
        message.success("Berhasil simpan data");
      },
      (err) => {
        console.log("err", err);
      }
    );
  };

  const handleCekToken = () => {
    if (searchParams.has("auth")) {
      let token = searchParams.get("auth");

      network.get(
        `perspektip-token?token=${token}`,
        {},
        (res) => {},
        (err, msg) => {
          console.log("msg", msg);
          window.location.replace("/");
        },
        () => {}
      );
    } else {
      window.location.replace("/");
    }
  };

  const handleFetchRoom = () => {
    if (searchParams.has("id")) {
      let id = searchParams.get("id");
      network.get(
        `get-room/${id}`,
        {},
        (res) => {
          setFUllImgDesktop(process.env.REACT_APP_STORAGE_URL + res.image_full);
          setPngImgDesktop(process.env.REACT_APP_STORAGE_URL + res.image);

          if (res.image_full_mobile === null) {
            setFUllImgMobile(
              process.env.REACT_APP_STORAGE_URL + res.image_full
            );
          } else {
            setFUllImgMobile(
              process.env.REACT_APP_STORAGE_URL + res.image_full_mobile
            );
          }

          if (res.image_mobile === null) {
            setPngImgMobile(process.env.REACT_APP_STORAGE_URL + res.image);
          } else {
            setPngImgMobile(
              process.env.REACT_APP_STORAGE_URL + res.image_mobile
            );
          }
        },
        (err, msg) => {
          console.log("msg", msg);
        },
        () => {}
      );
    } else {
      window.location.replace("/");

      return;
    }
  };

  var constAngle = 0;
  var constZoom = -50;

  useEffect(() => {
    if (utils.fetchLocalStorage("language")) {
      i18n.changeLanguage(utils.fetchLocalStorage("language"));
    }
  }, []);

  const handleChangeSlider = (val) => {
    setValArah(val);
    // handle rotate image
    const angle = val + ((val * 10) / window.innerHeight) * 180;

    // for handle when user swipe the screen
    // it doesnt spin anywhere
    const vxyz = [0, 0, 0];

    // update the rotation
    setRotation({
      rotation: [constZoom, 0, angle],
      immediate: true,
      config: { velocity: vxyz, decay: true },
    });
    constAngle = angle;
  };

  const handleArrangeFloor = (val) => {
    // handle zoom image
    setValZoom(val + 1);

    const zoom = val + ((val * 10) / window.innerHeight) * 180; // 550 for ipad

    // for handle when user swipe the screen
    // it doesnt spin anywhere
    const vxyz = [0, 0, 0];

    // update the rotation
    setRotation({
      rotation: [zoom, 0, constAngle],
      immediate: true,
      config: { velocity: vxyz, decay: true },
    });
    constZoom = zoom;
  };

  const handleArrangeFloorIpad = (val) => {
    if (imgWidth > imgHeight) {
      // handle zoom image
      const zoom = val + ((val * 5) / window.innerHeight) * 540; // 550 for ipad

      // for handle when user swipe the screen
      // it doesnt spin anywhere
      const vxyz = [0, 0, 0];

      // update the rotation
      setRotation({
        rotation: [zoom, 0, constAngle],
        immediate: true,
        config: { velocity: vxyz, decay: true },
      });
      constZoom = zoom;
    } else {
      // handle zoom image
      const zoom = val + ((val * 5) / window.innerHeight) * 640; // 550 for ipad

      // for handle when user swipe the screen
      // it doesnt spin anywhere
      const vxyz = [0, 0, 0];

      // update the rotation
      setRotation({
        rotation: [zoom, 0, constAngle],
        immediate: true,
        config: { velocity: vxyz, decay: true },
      });
      constZoom = zoom;
    }
  };

  const [imgWidth, setImageWidth] = useState(null);
  const [imgClient, setImageClient] = useState(null);
  const [imgHeightClient, setImageHeightClient] = useState(null);
  const [imgHeight, setImageHeight] = useState(null);
  const [imageIsReady, setImageIsReady] = useState(false);

  const handleImageLoad = (event) => {
    // real code
    const imWidth = event.target.naturalWidth;
    const imgHeight = event.target.naturalHeight;

    if (imWidth < imgHeight) {
      setImageWidth(window.innerWidth);
      setImageHeight(window.innerHeight - 100);
    } else {
      setImageWidth(imWidth);
      setImageHeightClient(imgHeight);
    }

    setImageClient(event.target.clientWidth);
    setImageHeight(event.target.clientHeight);

    setImageIsReady(true);

    hendleStyleCanvas();
  };

  const ref = createRef();

  // handle to download image
  const handleDownload = () => {
    setLoadingUp(true);
    toPng(ref.current)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "TACO IMAGE.png";
        link.href = dataUrl;
        link.click();
      })
      .then((res) => {
        setLoadingUp(false);
      })
      .catch((err) => {
        console.log(err, "Error code");
        setLoadingUp(false);
      });
  };

  const handleCaptureClick = useCallback(async () => {
    setLoadingUp(true);
    const pricingTableElmt = document.querySelector(
      "#layout__desktop__download"
    );
    if (!pricingTableElmt) return;

    const canvas = await html2canvas(pricingTableElmt);

    const dataURL = canvas.toDataURL("image/png");
    downloadjs(dataURL, "TACO IMAGE.png", "image/png");

    setLoadingUp(false);
  }, []);

  // screenshot the element
  // const getImage = () => takeScreenshot(ref.current).then(handleDownload);

  // choose floor to be set in CANVAS
  const handleChooseFloor = (floor) => {
    let imageFLoor = getBase64FromUrl(floor);
    handleLoading();
    setChoosedFloor(floor);
  };

  const fetchPattern = (id) => {
    network.get(
      `pattern-by-product/${id}`,
      {},
      (res) => {
        setPatterns(res.layouts);
      },
      (err, msg) => {
        let errmsg = utils.erorCode(err);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const fetchPatternAssets = (id) => {
    network.get(
      `asset`,
      { product_id: id },
      (res) => {
        if (res.data.length > 0) {
          let imgURL = process.env.REACT_APP_STORAGE_URL + res.data[0].image;

          handleChooseFloor(imgURL);
          setPatternsAssets(res.data);
          setSelectedPattern(res.data[0].id);
          utils.saveLocalStoreage("_pattern_id", res.data[0].layout_id);
        } else {
          utils.messageError("Tidak ada asset pattern untuk product ini!");
        }
      },
      (err, msg) => {
        let errmsg = utils.erorCode(err);
        utils.messageError(errmsg);
      },
      () => {
        setLoading(false);
      }
    );
  };

  // choose floor to be set in CANVAS
  const handleSelectProduct = (id) => {
    utils.saveLocalStoreage("_product_id", id);
    setSelectedPattern(0);
    setPatterns([]);
    setPatternsAssets([]);

    fetchPattern(id);
    fetchPatternAssets(id);
    setSelectedProduct(id);
    getArah(id);
  };

  useEffect(() => {
    if (utils.fetchLocalStorage("product_by_name")) {
      const productByName = utils.fetchLocalStorage("product_by_name");
      handleSelectCategory(productByName.category_id);
      handleSelectProduct(productByName.id);
    }
  }, []);

  // select category and show the product
  const handleSelectCategory = (id) => {
    setLoading(true);
    network.get(
      `kategori/${id}`,
      {},
      (res) => {
        utils.saveLocalStoreage("_category_id", id);
        setProducts(res.data.product);
        setShowed("products");
      },
      (err, msg) => {
        let errmsg = utils.erorCode(err);
        utils.messageError(errmsg);
      },
      () => {
        setLoading(false);
      }
    );
  };

  const hendleStyleCanvas = () => {
    if (550 <= window.innerWidth && window.innerWidth < 800) {
      setStyleWidth({ width: `100%`, height: "450px" });
    } else {
      if (window.innerWidth < 550) {
        if (imgWidth >= imgHeight) {
          setStyleWidth({ width: `100%`, height: "250px" });
        } else {
          setStyleWidth({
            height: `${imgHeight ?? 0}px`,
            width: `${imgWidth ?? 0}px`,
          });
        }
      } else {
        if (imgWidth >= imgHeight) {
          setStyleWidth({ width: `${imgClient ?? 0}px` });
        } else {
          setStyleWidth({
            height: `${imgHeight ?? 0}px`,
            width: `${imgWidth ?? 0}px`,
          });
        }
      }
    }
  };

  const styleCanvasFrame =
    550 <= window.innerWidth && window.innerWidth < 800
      ? { width: `100%`, height: "450px" }
      : window.innerWidth < 550
      ? imgWidth >= imgHeight
        ? { width: `100%`, height: "250px" }
        : {
            height: `${imgHeight ?? 0}px`,
            width: `${imgWidth ?? 0}px`,
            // border: "1px solid green",
          }
      : imgWidth >= imgHeight
      ? {
          width: `${imgClient ?? 0}px`,
          height: imgHeight,
          // border: "1px solid yellow",
        }
      : {
          width: `${imgClient ?? 0}px`,
          height: imgHeight,
          // border: "4px solid yellow",
        };

  // useEffect(() => {
  //   console.log("width client", imgClient);
  //   console.log("height client", imgHeight);
  //   console.log(imgWidth >= imgHeight);
  // });

  useEffect(() => {
    setLoading(true);
    network.get(
      `list-kategori`,
      {},
      (res) => {
        setFloors(res.data);
      },
      (err, msg) => {
        let errmsg = utils.erorCode(err);
        utils.messageError(errmsg);
      },
      () => {
        setLoading(false);
      }
    );

    if (searchParams.has("token")) {
      network.get(
        `share`,
        { ref: searchParams.get("token") },
        (res) => {
          setChoosedFloor(res.data.url_layout);
          setImage(res.data.image);
        },
        (err, msg) => {
          let errmsg = utils.erorCode(err);
          utils.messageError(errmsg);
        },
        () => {
          setLoading(false);
        }
      );
    }
  }, [searchParams]);

  const handleBackCarousel = () => {
    setSelectedPattern(0);
    setPatterns([]);
    setPatternsAssets([]);
    if (showed === "bricks") {
      setShowed("products");
    } else if (showed === "products") {
      setShowed("category");
    }
  };

  const handleSelectPattern = (val) => {
    let res = patternsAssets.filter((item) => item.layout_id === val);

    if (res.length > 0) {
      let imgURL = process.env.REACT_APP_STORAGE_URL + res[0].image;
      utils.saveLocalStoreage("_pattern_id", val);
      handleChooseFloor(imgURL);
      setSelectedPattern(res[0].id);
    }
  };

  const LoadingSection = () => {
    return (
      <AliceCarousel
        responsive={{
          1600: {
            items: 9,
          },
          1440: {
            items: 8,
          },
          1280: {
            items: 8,
          },
          991: {
            items: 6,
          },
          768: {
            items: 5,
          },
          660: {
            items: 4,
          },
          425: {
            items: 4,
          },
          375: {
            items: 3,
          },
          200: {
            items: 3,
          },
        }}
        mouseTracking
        items={skeletonItems}
      ></AliceCarousel>
    );
  };

  const CategorySection = () => {
    return loading ? (
      <LoadingSection />
    ) : floors.length <= 0 ? (
      <>
        <h3 className="fc-white">
          <i>Data not found!</i>
        </h3>
      </>
    ) : (
      <>
        <div className="mb-3 text-white text-left fw-bold pilih__Kategori">
          {" "}
          {t("Pilih Kategori")}
        </div>
        <div className="row">
          {floors.map((item, i) => {
            // console.log(item, "Item");
            return (
              <div className="col-md-6 mb-4" key={i}>
                <div
                  className="card card__category "
                  onClick={() => {
                    handleSelectCategory(item.id);
                  }}
                >
                  <div className="p-2">
                    <div className="d-flex">
                      <div className="text-white">
                        <span>2</span> <div className="categori">MM</div>
                      </div>
                      <img src="" alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div className="card__footer text-white text-left p-2 pb-3">
                    {item.name}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const ProductsSection = () => {
    return loading ? (
      <LoadingSection />
    ) : products.length <= 0 ? (
      <>
        <h3 className="fc-white">
          <i>Data not found!</i>
        </h3>
      </>
    ) : (
      <>
        <div className="mb-3  text-white text-left fw-bold pilih__Kategori">
          <div
            className="d-flex align-items-center"
            style={{ cursor: "pointer" }}
            onClick={handleBackCarousel}
          >
            <img src={arrowLeft} alt="" className="arrow_icon mr-3" />
            {t("Pilih motif")}
          </div>
        </div>
        <div className="row">
          {products.map((item, i) => {
            return (
              <div className="col-md-6 mb-4" key={i}>
                <div
                  className={`card card__products ${
                    item.id === selectedProduct ? "active" : ""
                  }`}
                  onClick={() => {
                    handleSelectProduct(item.id);
                  }}
                >
                  <img
                    src={process.env.REACT_APP_STORAGE_URL + item.image}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="card__footer text-white text-left p-2 pb-3">
                    <p className="mb-0 fc-white">{item.name}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const createShareLink = () => {
    let form = {
      image_url: utils.fetchLocalStorage("_image"),
      product_id: selectedProduct,
      asset_id: selectedPattern,
      url_layout:
        choosedFloor === null
          ? patternsAssets.length === 0
            ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAGxZgBhnD-ZxjaxZixSb-dVclOiqQWSUdSw&usqp=CAU"
            : process.env.REACT_APP_STORAGE_URL + patternsAssets[0].image
          : choosedFloor,
    };

    if (utils.fetchLocalStorage("is_upload")) {
      form.is_upload = 1;
    }

    network.post(
      `create-share-link`,
      form,
      (res) => {
        setTokenShare(res.data.ref);
        triggerModalShare(res.data);
        utils.saveLocalStoreage("_share_image_id", res.data.id);
      },
      (err) => {},
      () => {}
    );
  };

  const triggerModalShare = () => {
    setisShareModalShow(true);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isShareModalShow, setisShareModalShow] = useState(false);
  const [tokenShare, setTokenShare] = useState("");

  const showModal = () => {
    setIsModalVisible(true);
  };

  // const [loadingImage, setLoadingImage] = useState(false);

  const handleLoading = () => {
    let lprogress = setTimeout(() => {
      clearInterval(lprogress);
    }, 2000);
  };

  // useEffect(() => {
  //   tagAction();
  // }, [valueZoom, valueZoom]);

  const tagAction = () => {
    if (edit) {
      return (
        <>
          <div className="mt-3">
            {/* <ExperimentActionPrespektifDisabled
              showed={showed}
              showSlider={selectedPattern === 0}
              // showSlider={true}
              token={searchParams.get("auth")}
              callbackArange={handleArrangeFloor}
              callbackSpin={handleChangeSlider}
              callbackCarousel={handleBackCarousel}
              imgWidth={imgWidth}
              imgHeight={imgHeight}
              propMin={valueZoom}
              arahVal={valueArah}
            /> */}
            <SliderZoom
              showSlider={selectedPattern === 0}
              callbackArange={handleArrangeFloor}
              imgWidth={imgWidth}
              imgHeight={imgHeight}
              propMin={valueZoom}
            />
            <SliderArah
              showSlider={selectedPattern === 0}
              callbackArange={handleArrangeFloor}
              arahVal={valueArah}
            />
          </div>

          <div className="mt-3">
            <div
              className="btn btn-prespektif btn-block w-100"
              onClick={() => {
                setEdit(false);
              }}
            >
              Edit
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="mt-3">
            <ExperimentActionPrespektif
              showed={showed}
              showSlider={selectedPattern === 0}
              // showSlider={true}
              token={searchParams.get("auth")}
              callbackArange={handleArrangeFloor}
              callbackSpin={handleChangeSlider}
              callbackCarousel={handleBackCarousel}
              imgWidth={imgWidth}
              imgHeight={imgHeight}
              propMin={null}
              // arahVal={valueArah > 0 ? valueArah : 0}
            />
          </div>

          <div className="mt-3">
            <div
              className="btn btn-prespektif btn-block w-100"
              onClick={saveArah}
            >
              Save
            </div>
          </div>
        </>
      );
    }
  };

  // *********** return data
  return (
    <>
      <Modal
        footer={false}
        className="modal__experiment"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <UploadField
          reload={true}
          callback={() => {
            let res = utils.fetchLocalStorage("_image");
            let resOrigin = utils.fetchLocalStorage("_originImage");
            setImage(res);
            setOriginImage(resOrigin);
            setIsModalVisible(false);
          }}
        />
      </Modal>

      {/* Modal share */}
      <Modal
        onCancel={() => setisShareModalShow(false)}
        footer={false}
        className="modal__experiment"
        onOk={() => setisShareModalShow(false)}
        visible={isShareModalShow}
      >
        <h4 className="fontw-6 fc-white">{t("Bagikan hasil eksperimen!")}</h4>
        <div className="exp__copy__link fontw-6">
          {window.location.href + "?token=" + tokenShare}
        </div>

        <div className="mt-3 fc-white">{t("Atau bagikan melalui :")}</div>
        <div className="d-flex mt-1">
          <FacebookShareButton
            url={window.location.href + "?token=" + tokenShare}
          >
            <FacebookIcon className="exp__social__btn" />
          </FacebookShareButton>
          <WhatsappShareButton
            url={window.location.href + "?token=" + tokenShare}
          >
            <WhatsappIcon className="exp__social__btn" />
          </WhatsappShareButton>
          <TwitterShareButton
            url={window.location.href + "?token=" + tokenShare}
          >
            <TwitterIcon className="exp__social__btn" />
          </TwitterShareButton>
          <LineShareButton url={window.location.href + "?token=" + tokenShare}>
            <LineIcon className="exp__social__btn" />
          </LineShareButton>

          <Tooltip placement="top" title="Tersalin!" trigger="click">
            <div
              className="exp__social__btn"
              onClick={() => {
                navigator.clipboard.writeText(
                  `${window.location.href}?token=${tokenShare}`
                );
              }}
            >
              <LinkOutlined />
            </div>
          </Tooltip>
        </div>
      </Modal>

      <div className="overflow-x-hidden">
        <div className="row">
          <div className="col-md-3 layout__right padding__new_layout">
            <div className="mb-5">
            <Link to="/home">
            <img
              src={logoBlack}
              className="img-fluid logo_nav custom-logo-style"
              alt=""
            />
          </Link>
            </div>
            {showed !== "category" ? (
              <>
                <div className="mb-2">
                  <div
                    className="d-flex align-items-center "
                    onClick={handleBackCarousel}
                    style={{ position: "relative" }}
                  >
                    <svg
                      width="13"
                      height="19"
                      viewBox="0 0 10 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="cursor-pointer"
                    >
                      <path
                        d="M8.07477 15.5L0 8L8.07477 0.5L10 2.28819L3.85047 8L10 13.7118L8.07477 15.5Z"
                        fill="black"
                        fillOpacity="0.4"
                      />
                    </svg>

                    <span className="ml-3 cursor-pointer kembali">
                      {t("KEMBALI")}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {!searchParams.has("token") && selectedPattern !== 0 ? (
              <></>
            ) : (
              <></>
            )}
            <div className="mt-3">
              {searchParams.has("token") || (
                <>
                  {showed === "category" ? (
                    <CategorySection />
                  ) : (
                    <>
                      <ProductsSection />
                      {patterns.length === 0 || patternsAssets.length === 0 || (
                        <div className="w-100 mb-2 mt-2 px-1">
                          <Select
                            className="w-100 select_experiment"
                            defaultValue={patterns[0].layout_id}
                            onChange={handleSelectPattern}
                            showArrow={false}
                          >
                            {patterns.map((item, idx) => (
                              <Option value={item.layout_id} key={idx}>
                                <div className="row no-gutters">
                                  <div className="col-8">
                                    <Image
                                      preview={false}
                                      src={
                                        process.env.REACT_APP_STORAGE_URL +
                                        item.layout_image
                                      }
                                      width={"100%"}
                                      height={49}
                                      alt="empty taco"
                                    />
                                  </div>
                                  <div className="col-4">
                                    <div className="bg__dark d-flex justify-content-center align-items-center">
                                      <p className="pl-2 mb-0 ">
                                        {item.layout_name}
                                      </p>
                                      {/* <div className="">
                                            <DownOutlined />
                                          </div> */}
                                    </div>
                                  </div>
                                </div>
                              </Option>
                            ))}
                          </Select>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="col-md-9 text-white">
            <div className="" id="layout__desktop__download">
              <div className="canvas__field mx-auto" style={styleCanvasFrame}>
                <Canvas
                  pixelRatio={window.devicePixelRatio || 1}
                  camera={{ fov: 75, position: [0, 0, 7] }}
                  gl={{ preserveDrawingBuffer: true }}
                >
                  <CanvasImage
                    className="rotated_floor"
                    url={
                      choosedFloor === null
                        ? patternsAssets.length === 0
                          ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAGxZgBhnD-ZxjaxZixSb-dVclOiqQWSUdSw&usqp=CAU"
                          : process.env.REACT_APP_STORAGE_URL +
                            patternsAssets[0].image
                        : choosedFloor
                    }
                    {...props}
                    rotation={rotation}
                  />
                </Canvas>
                {image === "" || (
                  <img
                    className="watermark_image"
                    src={watermark}
                    alt="empty watermark"
                  />
                )}
              </div>

              <img
                src={
                  choosedFloor === null && patternsAssets.length === 0
                    ? originImage
                    : image
                }
                onLoad={handleImageLoad}
                alt="taco empty new-layout"
                className={"img-fluid image__rooom"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
